import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useUser } from '../context/UserContext';

export default function RequireUser() {
    const { currentUser, isAuthLoading } = useUser();
    const location = useLocation();

    if (isAuthLoading) {
        return <div className="text-center p-5"><div className="spinner-border text-danger" role="status" /></div>;
    }

    if (!currentUser || !currentUser.id) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return <Outlet />;
}
